import { ReactNode } from "react";
import { usePlan, isRouteLocked } from "@/hooks/usePlan";
import { UpgradePrompt } from "@/components/UpgradePrompt";
import { useLocation } from "react-router-dom";

interface PlanGateProps {
  feature: string;
  description?: string;
  children: ReactNode;
}

/** Wraps a page to show an upgrade prompt if the current plan doesn't include this feature */
export function PlanGate({ feature, description, children }: PlanGateProps) {
  const { isStarter, isLoading } = usePlan();
  
  if (isLoading) return null;
  
  if (isStarter) {
    return <UpgradePrompt feature={feature} description={description} />;
  }

  return <>{children}</>;
}
